import type { MouseEventHandler, ReactNode, Ref } from 'react'
import styles from './SplitViewToggleButton.module.css'
import { RawButton } from '@/components/Button'

interface SplitViewToggleButtonProps {
  children?: ReactNode
  position?: 'left' | 'right'
  onPress?: MouseEventHandler
  ref?: Ref<HTMLButtonElement>
}

/**
 * Shows or hides a split view pane.
 */
export function SplitViewToggleButton({
  position,
  children,
  onPress,
  ref,
}: SplitViewToggleButtonProps) {
  return (
    <div
      className={
        position === 'right'
          ? styles.toggleContainerRight
          : styles.toggleContainerLeft
      }
    >
      <RawButton className={styles.toggle} onPress={onPress} ref={ref}>
        {children}
      </RawButton>
    </div>
  )
}
